<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">

        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Add Role</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="submit">
                    <div class="row">

                        <div class="col-md-5">
                            <label>Role<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.roledata.role.$model" type="text" label="Role" placeholder="Enter role" />
                            <div class="error" v-if="submitted && !$v.roledata.role.required">Please enter role</div>

                        </div>
                        <!-- </div> -->

                        <!-- <div class="row"> -->
                        <div class="col-md-5">
                            <label>Status<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.roledata.status.$model">
                                <option disabled>Select status</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                            </select>
                            <div class="error" v-if="submitted && !$v.roledata.status.required">Please select status</div>

                        </div>

                    </div>

                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Add Role</button>&nbsp;
                        <router-link to="/admin/dashboard/role"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>

                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
} from "vuelidate/lib/validators";
export default {
    name: 'addRole',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
    },

    data() {
        return {
            submitted: false,

            roledata: {
                role: '',
                status: 1,
            }
        }
    },

    validations: {
        roledata: {
            role: {
                required,
            },
            status: {
                required,
            },
        }
    },

    methods: {
        submit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/addrole`, this.roledata)
                    .then(({
                        data
                    }) => {
                        this.flashMessage.success({
                            message: 'Role Added Successfully',
                        });

                        this.$router.push('/admin/dashboard/role');
                    })
                // .catch((error) => {
                //     console.log(error);
                // });

            }
        }
    },

};
</script>

<style lang="scss">
</style>
